import { render, staticRenderFns } from "./aboutNews.vue?vue&type=template&id=5aba10f6&"
import script from "./aboutNews.vue?vue&type=script&lang=js&"
export * from "./aboutNews.vue?vue&type=script&lang=js&"
import style0 from "./aboutNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports